





































































//codificamos en ts

//importando clases
import { fetchTransbank } from './fetchTransbank';
import MantenedorGrid from '@/reusable/Grid/MantenedorGrid.vue';
import DatePicker from '@/reusable/Form/DatePicker.vue';
import moment from 'moment';
import FormFieldsContainer from '@/reusable/Form/FormFieldsContainer.vue';
import { Component } from 'vue-property-decorator';
import { utils, writeFileXLSX } from 'xlsx';
import { ComponenteBase, Accion } from '@/views/base/ComponenteBase';
import {
  FormFieldDefMap,
  emitFormChangeEvent,
} from '@/reusable/Form/formUtils'; //plantilla
import { Funcionalidades } from '@/config/funcionalidades';
import { PermisoAccion } from '@/views/base/VariablesPermisos';
import { GridOptions, GridApi, GridReadyEvent } from 'ag-grid-community';
import MantenedorGridSinCodigo from '@/reusable/Grid/MantenedorGridSinCodigo.vue';
import { actionsEvent } from '@/setup';

@Component({
  components: {
    MantenedorGrid,
    DatePicker,
    FormFieldsContainer,
    MantenedorGridSinCodigo,
  },
})
export default class ConfigurarPantallaTransbank extends ComponenteBase {
  //llamamos a una clase para trabajar aqui dentro
  readonly funcionalidad: Funcionalidades = Funcionalidades.MantenedorTransbank;
  accionesTotales: PermisoAccion[];
  ordesList: any[] = [];
  estadoLista: any[] = [];
  configurarTransbank: any[] = null;
  serverSide: any;
  constructor() {
    super();
    actionsEvent.onActualizarEstado(this.actualizarEstado);
  }

  actualizarEstado(params: any) {
    const data = params.data;
    this.loadingService.showLoading();
    //console.log('data -> ',data)
    fetchTransbank(
      {
        id_trx: data['id_trx'],
        folio: data['folio'],
        tbk_token: data['tbk_token'],
        status: data['status'],
      },
      'transbank/get_status'
    )
      .then((data: any) => {
        if (data.data.CODIGO_RESPUESTA == '1') {
          this.$snotify.success(data.data.MENSAJE_RESPUESTA, { timeout: 3000 });
          this.gridApi.setRowData(this.ordesList);
        } else {
          this.$snotify.error(data.data.MENSAJE_RESPUESTA, { timeout: 3000 });
          this.gridApi.setRowData(this.ordesList);
        }
      })
      .catch((error: any) => {
        this.$snotify.error('Ocurrió un error', { timeout: 3000 });
      })
      .finally(() => {
        this.loadingService.hideLoading();
        this.handleBuscar();
      });
  }
  //funcion para fechas
  get fechaMaxima() {
    let today = new Date();
    let dd = String(today.getDate()).padStart(2, '0');
    let mm = String(today.getMonth() + 1).padStart(2, '0'); //January is 0!
    let yyyy = today.getFullYear();

    let fechaMax = yyyy + '-' + mm + '-' + dd;
    return fechaMax;
  }
  get fechaMaximaInicio() {
    return moment(this.fechaMaxima) as moment.Moment;
    //return fechaMax as moment.Moment;
  }
  //funcion limpiar
  async clearFilters() {
    this.formFields.fechaInicio.value = moment().subtract(1, 'month');
    this.formFields.fechaFinal.value = moment();
    this.formFields.folio.value = '';
    this.formFields.Estado.value = '';
    this.$emit('clear');
    this.handleBuscar();
    this.gridApi.setRowData(this.ordesList);
    this.gridApi.setDomLayout('autoHeight');
  }

  async handleBuscar() {
    const resultadoValidacion = await this.$validator.validateAll();
    let self = this;
    this.loadingService.showLoading();
    return fetchTransbank(
      {
        folio: this.formFields.folio.value,
        estado: this.formFields.Estado.value,
        fechaInicio: this.formFields.fechaInicio.value,
        fechaFinal: this.formFields.fechaFinal.value,
      },
      'transbank/get_pagos'
    )
      .then((data: any) => {
        if (data.data.CODIGO_RESPUESTA == '1') {
          //console.log('data', data)
          this.ordesList = data.data.LISTA;
          this.gridApi.setRowData(this.ordesList);
        } else {
          self.$snotify.error(data.data.MENSAJE_RESPUESTA, { timeout: 3000 });
          this.ordesList = [];
          this.gridApi.setRowData(this.ordesList);
        }
      })
      .catch((error: any) => {
        self.$snotify.error('Ocurrió un error', { timeout: 3000 });
      })
      .finally(() => {
        this.loadingService.hideLoading();
        return null;
      });
  }

  formFields: FormFieldDefMap = {
    folio: {
      label: 'Folio',
      id: '',
      value: '',
    },
    Estado: {
      label: 'Estado Pago',
      id: '',
      value: '',
    },
    fechaInicio: {
      label: 'Fecha Inicio',
      id: 'fechaInicio',
      value: moment().subtract(1, 'month'),
    },
    fechaFinal: { label: 'Fecha Final', id: 'fechaFin', value: moment() },
  };

  gridApi: GridApi = null;
  readonly gridOptions: GridOptions = {
    columnDefs: [
      {
        headerName: 'Rut Cliente',
        field: 'rutcliente',
        cellStyle: { textAlign: 'left' },
      },
      {
        headerName: 'Rut Usuario',
        field: 'rutusuario',
        cellStyle: { textAlign: 'left' },
      },
      {
        headerName: 'Email Usuario',
        field: 'mail_usuario',
        cellStyle: { textAlign: 'left' },
      },
      {
        headerName: 'Folio',
        field: 'folio',
        cellStyle: { textAlign: 'left' },
      },
      {
        headerName: 'ID Transaccion',
        field: 'id_trx',
        cellStyle: { textAlign: 'left' },
      },
      {
        headerName: 'Monto',
        field: 'monto',
        cellStyle: { textAlign: 'left' },
        valueFormatter: params =>
          `$${parseInt(params.value).toLocaleString('es-CL')}`,
      },
      {
        headerName: 'Estado Pago',
        field: 'estado',
        cellStyle: { textAlign: 'left' },
      },
      {
        headerName: 'Fecha',
        field: 'fecha',
        cellStyle: { textAlign: 'left' },
        valueFormatter: function(params) {
          return moment(params.value).format('YYYY-MM-DD' + ' HH:mm:ss');
        },
      },
    ],

    pagination: true,
    paginationPageSize: 25,
    onGridReady: this.handleGridReady,
  };

  async handleGridReady(event: GridReadyEvent) {
    this.handleBuscar();
    this.gridApi = event.api;
    //console.log(this.ordesList);
    this.gridApi.setRowData(this.ordesList);
    this.gridApi.setDomLayout('autoHeight');
  }

  exportFile() {
    const newList = this.ordesList.map(item => {
      return {
        'Rut Cliente': item.rutcliente,
        'Rut Usuario': item.rutusuario,
        'Email Usuario': item.mail_usuario,
        Folio: item.folio,
        'ID Transaccion': item.id_trx,
        Monto: item.monto,
        'Estado Pago': item.estado,
        Fecha: moment(item.fecha).format('YYYY-MM-DD' + ' HH:mm:ss'),
      };
    });
    if (newList.length < 1) {
      this.$snotify.warning('No existen datos para exportar.');
    } else {
      const ws = utils.json_to_sheet(newList);
      ws['A1'].v = 'Rut Cliente';
      ws['B1'].v = 'Rut Usuario';
      ws['C1'].v = 'Mail Usuario';
      ws['D1'].v = 'Folio';
      ws['H1'].v = 'ID Transaccion';
      ws['F1'].v = 'Monto';
      ws['G1'].v = 'Estado';
      ws['H1'].v = 'Fecha';

      const wb = utils.book_new();
      utils.book_append_sheet(wb, ws, 'Data');
      writeFileXLSX(wb, 'ReportesTransbank.xlsx');
      this.$snotify.success(
        this.$t('mensajes.mensajesExito.exportar').toString()
      );
    }
  }
}
